<template>
  <base-page-layout title="Segmentação">
    <div class="tabs-button-header">
      <mf-tabs-menu v-model="tab" :tabs="tabs" />
      <div class="button-new">
        <segmentation-models v-if="tab !== 1" ref="carregarModeloDialog" @selected-model="submit" />
      </div>
    </div>

    <div v-if="tab === 0" :key="tab">
      <segmentation-table :isIndustry="false" @loading-action="setLoadingValue">
        <template v-slot:title> Minhas segmentações </template>
      </segmentation-table>
    </div>

    <!-- <div v-if="tab === 1" :key="tab">
      <segmentation-table :isIndustry="true" @loading-action="setLoadingValue">
        <template v-slot:title> Segmentações de trade </template>
      </segmentation-table>
    </div> -->

    <loading-dialog-standalone :loading="loading" />
  </base-page-layout>
</template>

<script>
import BasePageLayout from '@/components/BasePageLayout.vue'
import SegmentationModels from '@/modules/clientes/segmentation/views/components/SegmentationModels.vue'
import SegmentationTable from '@/modules/clientes/segmentation/views/components/SegmentationTable.vue'

export default {
  components: {
    BasePageLayout,
    SegmentationModels,
    SegmentationTable,
    LoadingDialogStandalone: () => import('@/components/LoadingDialogStandalone.vue'),
  },
  data: () => ({
    loading: false,
    tab: 0,
  }),
  computed: {
    tabs() {
      return [
        {
          name: 'Minhas segmentações',
          itemsLength: 0,
          haveLength: false,
        },
        // {
        //   name: 'Segmentações de trade',
        //   itemsLength: 0,
        //   haveLength: false,
        // },
      ]
    },
  },
  // watch: {
  //   tab(newValue, oldValue) {
  //     if (this.tab === 1) {
  //       if (this.$route.name !== 'segmentacao-trade') {
  //         this.$router.push({ name: 'segmentacao-trade' })
  //       }
  //     } else {
  //       if (this.$route.name !== 'segmentacao') {
  //         this.$router.push({ name: 'segmentacao' })
  //       }
  //     }
  //   },
  // },
  // mounted() {
  //   if (this.$route.name === 'segmentacao-trade') {
  //     this.tab = 1
  //   }
  // },
  methods: {
    submit(id) {
      this.$router.push({ path: `/clientes/segmentacao/nova/${id}` }).catch(() => {})
    },
    setLoadingValue(value) {
      this.loading = value
    },
  },
}
</script>

<style lang="scss" scoped>
.tabs-button-header {
  position: relative;
  margin-bottom: 20px;

  .button-new {
    position: absolute;
    top: 5px;
    right: 0;
  }
}
</style>
